import React, { useEffect, useState } from 'react';
import Dropdown, { MenuItem } from '@ids-ts/dropdown';
import IndeterminateShort from '@ids/indeterminate-short';
import Button from '@ids/button';
import { getBundlePricingInfo } from '../../../services/productDataService';
import {
  setSessionStorage,
  removeSessionStorage,
  currencyFormatter,
  convertToSnakeCase,
} from '../../Util/CommonUtils.jsx';

export const BundlePricingSection = (props) => {
  const { pageData, history } = props;
  const defaultDepSlipType = '3';
  const [selectedPart, setSelectedPart] = useState();
  const [selectedQuantity, setSelectedQuantity] = useState(null);
  const [bundleSkus, setBundleSkus] = useState();
  const [sortedSku, setSortedSku] = useState();
  const [fetchError, setFetchError] = useState(false);
  const [loading, setLoading] = useState(true);

  const isButtonDisabled = () => {
    return !selectedQuantity;
  };

  const startCustomization = () => {
    removeSessionStorage('Bundle_data');
    removeSessionStorage('Bundle_Key');
    const customizationLink = pageData.Department.PricingInformation.Link;
    const Bundle_data = {
      pfId: pageData.Department.PFID,
      sku: selectedQuantity,
    };
    setSessionStorage('Bundle_data', JSON.stringify(Bundle_data));
    if (pageData.Department.PricingInformation.LinkEnabled) history.push(customizationLink);
    else window.open(customizationLink, '_self');
  };

  const setQuantity = (skuData, part) => {
    const sorted_Sku = skuData
      .filter((sku) => {
        return sku.SKUOrder === parseInt(part);
      })
      .sort((a, b) => {
        return a.ChequeCount > b.ChequeCount && a.EnvelopeCount > b.EnvelopeCount
          ? 1
          : a.ChequeCount < b.ChequeCount && a.EnvelopeCount < b.EnvelopeCount
          ? -1
          : 0;
      });
    setSortedSku(sorted_Sku);
    setSelectedPart(part);
    setSelectedQuantity(sorted_Sku[0].SKU);
  };

  const handlePartsChange = (e) => {
    setSelectedPart(e.target.value);
    setQuantity(bundleSkus, e.target.value);
  };

  useEffect(() => {
    getBundlePricingInfo(pageData.Department.PFID)
      .then((res) => {
        setLoading(false);
        if (res) {
          setBundleSkus(res);
          setQuantity(res, defaultDepSlipType);
        }
      })
      .catch((err) => {
        setLoading(false);
        setFetchError(true);
        console.log(
          'Error',
          `Value packs product page: getBundlePricingInfo failed. Error: ${err}`,
        );
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (loading) {
    return (
      <div style={{ textAlign: 'center' }}>
        <IndeterminateShort theme="quickbooks" />
      </div>
    );
  }
  return (
    <div>
      <div>
        <Dropdown
          label="Type of deposit slips / number of parts"
          theme="quickbooks"
          data-wa-link="deposit slips parts"
          data-ui-object="dropdown"
          data-ui-object-details="Type of deposit slips / number of parts"
          data-refer-ui-access-point={`deposit_slips_parts|${convertToSnakeCase(
            pageData.Department.DeptName,
          )}`}
          buttonType="secondaryGhost"
          onChange={handlePartsChange}
          value={selectedPart}
          className="margin-bottom-20 dropdown-background-color-white-label"
          styleOverrideReason="none"
        >
          {pageData.Department.PricingInformation.depositSlipsParts.map((s, key) => {
            return <MenuItem key={`${key}`} value={`${s.Value}`}>{`${s.Label}`}</MenuItem>;
          })}
        </Dropdown>
      </div>
      <Dropdown
        // Added html space to acheive same width as the above dropdown
        label="Quantity&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&thinsp;&thinsp;"
        theme="quickbooks"
        buttonType="secondaryGhost"
        onChange={(e) => setSelectedQuantity(e.target.value)}
        value={selectedQuantity}
        className="bundle-qty margin-bottom-20 dropdown-background-color-white-label"
        styleOverrideReason="none"
        errorText={fetchError ? 'Unable to fetch the value.' : null}
      >
        {sortedSku ? (
          sortedSku.map((q, key) => {
            return (
              <MenuItem key={`${key}`} value={`${q.SKU}`}>
                {`${q.ChequeCount} checks,  
                  ${q.EnvelopeCount} envelopes,
                  ${q.DepositSlipCount} deposit slips${
                  q.HasEndorsementStamp ? ', endorsement stamp' : ''
                }
                  for ${
                    q.DiscPrice ? currencyFormatter(q.DiscPrice) : currencyFormatter(q.ListPrice)
                  }`}
              </MenuItem>
            );
          })
        ) : (
          <MenuItem disabled value="0">
            Select type of deposit slips
          </MenuItem>
        )}
      </Dropdown>

      <Button
        theme="intuit"
        className="margin-bottom-20 pricing-btn"
        styleOverrideReason="none"
        disabled={isButtonDisabled()}
        data-wa-link="Get Started"
        data-ui-object="button"
        data-refer-ui-access-point={`get_started|${convertToSnakeCase(
          pageData.Department.DeptName,
        )}`}
        onClick={startCustomization}
      >
        Get started
      </Button>

      <p className="p2-regular bottom-statement">
        Orders typically ship within 48 hours. Custom orders may require up to six days. Rush orders
        available. Please call <span className="font-wgt-500">(866) 570-3842.</span>
      </p>
    </div>
  );
};
